import { useTranslation } from "react-i18next";

import NoPermissionIcon from "assets/customIcons/emptyTable/NoPermissionIcon";

import { useSharedContainerStyle } from "./hooks";

const NoPermission = () => {
    const { t } = useTranslation();
    const sharedStyle = useSharedContainerStyle();

    return (
        <div css={sharedStyle}>
            <NoPermissionIcon />

            <div>
                <div>{t("Table##empty table##no permission##title")}</div>
                <div>{t("Table##empty table##no permission##description")}</div>
            </div>
        </div>
    );
};

export default NoPermission;
